import React from "react";
import { VbzModal, VbzButton } from "@smiles/voebiz-ui-kit";
import { ModalHeader, ModalBody } from "reactstrap";

type BtnPrimaryColorType = "primary" | "secondary" | "hyperlink" | "pills";
interface ModalErrorInterface {
  id?: string;
  isOpen?: boolean;
  errorTitle?: string | HTMLElement;
  idTitle?: string;
  errorMsg?: any;
  idMessage?: string;
  handleCloseModal?: (e: React.MouseEvent) => void;
  onClickPrimary?: (e: React.MouseEvent | React.FormEvent) => void;
  onClickSecondary?: (e: React.MouseEvent) => void;
  onClosed?: () => void;
  btnTextPrimary?: string;
  btnTextSecondary?: string;
  btnIdPrimary?: string;
  btnPrimaryColor?: BtnPrimaryColorType;
  btnIdSecondary?: string;
  labelIdPrimary?: string;
  labelIdSecondary?: string;
}

const ModalError: React.FC<ModalErrorInterface> = ({
  id = "",
  isOpen,
  errorTitle = "",
  idTitle,
  errorMsg = "",
  idMessage,
  handleCloseModal,
  onClickPrimary,
  onClickSecondary,
  btnTextPrimary = "",
  btnPrimaryColor = "primary",
  btnTextSecondary = "",
  btnIdPrimary,
  btnIdSecondary,
}) => {
  return (
    <VbzModal
      id={id}
      isOpen={isOpen}
      type="right"
      defaultHeader={false}
      className="vbz-register-error-modal"
      toggle={handleCloseModal}
    >
      <ModalHeader>
        <button
          id="btn_close"
          type="button"
          className="vbz-btn-close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={handleCloseModal}
        >
          <i className="material-icons">&#xe5cd;</i>
        </button>
      </ModalHeader>

      <ModalBody>
        <div className="vbz-modal-header">
          <h4 id={idTitle}>{errorTitle}</h4>
        </div>
        <div className="vbz-modal-text">
          <p id={idMessage}>{errorMsg}</p>
        </div>
        <form className="vbz-form-btn" onSubmit={onClickPrimary}>
          <VbzButton
            id={btnIdPrimary}
            className="vbz-register-cpf"
            color={btnPrimaryColor}
            text={btnTextPrimary}
            onClick={onClickPrimary}
          />
          {btnIdSecondary && (
            <VbzButton
              id={btnIdSecondary}
              className="voebiz-register-hyperlink"
              color="hyperlink"
              text={btnTextSecondary}
              onClick={onClickSecondary}
            />
          )}
        </form>
      </ModalBody>
    </VbzModal>
  );
};

export default ModalError;
